import { IonButton, IonImg } from "@ionic/react";
import gastrocnemiusStretchModalImg from "../../assets/images/gastrocnemius-stretch-modal-img.png";
import { useRecoilValue } from "recoil";
import { allExercisesState } from "../../data/atoms";
interface Props {
  setExerciseDetailModal: Function;
  selectedExerciseDetail: any;
}
const ExerciseDetailModal: React.FC<Props> = ({
  setExerciseDetailModal,
  selectedExerciseDetail,
}) => {
  debugger;

  const allExercises = useRecoilValue(allExercisesState);
  console.log(allExercises);
  return (
    <>
      <div className="all-generic-new-modal-center exercise-list-modal-main-wrap">
        <div className="exercise-list-modal">
          <div
            className="cross-icon"
            onClick={() => setExerciseDetailModal(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
            >
              <path
                d="M15.9999 15.9999L3 3"
                stroke="#D1D1D1"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16 3L3 16"
                stroke="#D1D1D1"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <IonImg
            src={selectedExerciseDetail.testExercises[0].gif}
            alt="gastrocnemiusStretchModalImg"
            placeholder={undefined}
            className="modal-img"
          ></IonImg>
          <h2>{selectedExerciseDetail.testName}</h2>
          <p className="ist-child">
            {selectedExerciseDetail.testExercises[0].overview}
          </p>
          <p>
            {" "}
            You may use a table, chair or other means of support for this
            exercise.
          </p>
          {(selectedExerciseDetail.testExercises[0].is5XSTS ||
            selectedExerciseDetail.testExercises[0].isGait ||
            selectedExerciseDetail.testExercises[0].ismCTSIB ||
            selectedExerciseDetail.testExercises[0].isTug ||
            selectedExerciseDetail.testExercises[0].isReach) && (
            <p>
              {" "}
              <u>Recommended Exercise due to results from:</u>
            </p>
          )}
          <div className="ex-btn-wrap">
            {selectedExerciseDetail.testExercises[0].isGait && (
              <>
                {allExercises.recommendedExercisesBasedOnAssessment.map(
                  (rec: any) => {
                    if (rec.vbTestLookupId === 22) {
                      return rec.mobility === "high" ? (
                        <span key={rec.id} className="ex-green">
                          Gait
                        </span>
                      ) : rec.mobility === "medium" ? (
                        <span key={rec.id} className="ex-orange">
                          Gait
                        </span>
                      ) : rec.mobility === "low" ||
                        rec.mobility === "ultralow" ? (
                        <span key={rec.id} className="ex-red">
                          Gait
                        </span>
                      ) : (
                        <span key={rec.id}></span>
                      );
                    }
                    return null;
                  }
                )}
              </>
            )}
            {selectedExerciseDetail.testExercises[0].is5XSTS && (
              <>
                {allExercises.recommendedExercisesBasedOnAssessment.map(
                  (rec: any) => {
                    if (rec.vbTestLookupId === 35) {
                      return rec.mobility === "high" ? (
                        <span key={rec.id} className="ex-green">
                          5x-STS
                        </span>
                      ) : rec.mobility === "medium" ? (
                        <span key={rec.id} className="ex-orange">
                          5x-STS
                        </span>
                      ) : rec.mobility === "low" ||
                        rec.mobility === "ultralow" ? (
                        <span key={rec.id} className="ex-red">
                          5x-STS
                        </span>
                      ) : (
                        <span key={rec.id}></span>
                      );
                    }
                    return null;
                  }
                )}
              </>
            )}
            {selectedExerciseDetail.testExercises[0].ismCTSIB && (
              <>
                {allExercises.recommendedExercisesBasedOnAssessment.map(
                  (rec: any) => {
                    if (rec.vbTestLookupId === 1) {
                      return rec.mobility === "high" ? (
                        <span key={rec.id} className="ex-green">
                          mCTSIB
                        </span>
                      ) : rec.mobility === "medium" ? (
                        <span key={rec.id} className="ex-orange">
                          mCTSIB
                        </span>
                      ) : rec.mobility === "low" ||
                        rec.mobility === "ultralow" ? (
                        <span key={rec.id} className="ex-red">
                          mCTSIB
                        </span>
                      ) : (
                        <span key={rec.id}></span>
                      );
                    }
                    return null;
                  }
                )}
              </>
            )}
            {selectedExerciseDetail.testExercises[0].isTug && (
              <>
                {allExercises.recommendedExercisesBasedOnAssessment.map(
                  (rec: any) => {
                    if (rec.vbTestLookupId === 31) {
                      return rec.mobility === "high" ? (
                        <span key={rec.id} className="ex-green">
                          Tug
                        </span>
                      ) : rec.mobility === "medium" ? (
                        <span key={rec.id} className="ex-orange">
                          Tug
                        </span>
                      ) : rec.mobility === "low" ||
                        rec.mobility === "ultralow" ? (
                        <span key={rec.id} className="ex-red">
                          Tug
                        </span>
                      ) : (
                        <span key={rec.id}></span>
                      );
                    }
                    return null;
                  }
                )}
              </>
            )}
            {selectedExerciseDetail.testExercises[0].isReach && (
              <>
                {allExercises.recommendedExercisesBasedOnAssessment.map(
                  (rec: any) => {
                    if (rec.vbTestLookupId === 2) {
                      return rec.mobility === "high" ? (
                        <span key={rec.id} className="ex-green">
                          Reach
                        </span>
                      ) : rec.mobility === "medium" ? (
                        <span key={rec.id} className="ex-orange">
                          Reach
                        </span>
                      ) : rec.mobility === "low" ||
                        rec.mobility === "ultralow" ? (
                        <span key={rec.id} className="ex-red">
                          Reach
                        </span>
                      ) : (
                        <span key={rec.id}></span>
                      );
                    }
                    return null;
                  }
                )}
              </>
            )}
          </div>
          <IonButton
            placeholder={undefined}
            className="generic-btn bg-blue"
            onClick={() => setExerciseDetailModal(false)}
          >
            Close
          </IonButton>
        </div>
      </div>
    </>
  );
};
export default ExerciseDetailModal;
